import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Success.css';

function Success() {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Get session ID from URL
    // eslint-disable-next-line no-undef
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      setSessionId(sessionId);
      
      // Activate Pro features in localStorage
      localStorage.setItem('isPro', JSON.stringify(true));
      localStorage.setItem('conversionsRemaining', '999');
      
      // Redirect to home after 3 seconds
      setTimeout(() => {
        navigate('/');
      }, 3000);
    }
  }, [navigate]);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">🎉</div>
        <h1>Welcome to PRO!</h1>
        <p>Your subscription has been activated successfully.</p>
        
        <div className="success-features">
          <h3>You now have access to:</h3>
          <ul>
            <li>✅ Unlimited PDF conversions</li>
            <li>✅ 50,000 character limit</li>
            <li>✅ All premium fonts</li>
            <li>✅ Priority support</li>
          </ul>
        </div>

        {sessionId && (
          <p className="session-info">
            <small>Session ID: {sessionId.substring(0, 20)}...</small>
          </p>
        )}

        <button className="return-button" onClick={() => navigate('/')}>
          Start Using PRO Features →
        </button>

        <p className="redirect-text">Redirecting automatically in 3 seconds...</p>
      </div>
    </div>
  );
}

export default Success;
